module.exports = __webpack_public_path__ + "img/salesman_index_dingdanBtn.6db08b95.png";